import { render, staticRenderFns } from "./NuxtLinkButton.vue?vue&type=template&id=70b0df0a&scoped=true&"
import script from "./NuxtLinkButton.vue?vue&type=script&lang=js&"
export * from "./NuxtLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./NuxtLinkButton.vue?vue&type=style&index=0&id=70b0df0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0df0a",
  null
  
)

export default component.exports